var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripe-card-list"},[_c('list',{ref:"stripeCardList",attrs:{"fs":_vm.stripeCardFields,"api":"stripe/cards","title":"Cards","beforeDelete":_vm.handleBeforeDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }